
import 'slick-carousel';
import Headroom from "headroom.js";
/* eslint-disable */
export default {
  init() {

    $(document).ready(function(){
      $('.nav-primary .sub-menu').each(function() {
        var width = $(this).parent().find('> a').width();
        width = width/2;
        width = Math.round(width);
        $(this).addClass('fix-'+width);
      });
      $('.nav-primary .menu-item-has-children').mouseenter(function(){
        $(this).find('ul').stop()
        $(this).find('ul').fadeIn(400)
      });
      $('.nav-primary .menu-item-has-children').mouseleave(function(){
        $(this).find('ul').stop()
        $(this).find('ul').fadeOut(400)
      });

      if (window.location.href.indexOf("contact-us") > -1) {
          var url = window.location.href;
          url = url.split('#')[1];
          if(url){
            $('#offices .tab-content .office-details').css('display', 'none');
            $('#offices .tab-content .'+url).css('display', 'block');
            $('#offices .tab-container .office').removeClass('active');
            $('#offices .tab-container #'+url).addClass('active');
          }
      }

      $('#offices .tab-container .office').click(function(){
        if($(this).hasClass('active')) {
        } else {
          $('#offices .tab-container .office').removeClass('active');
          $(this).addClass('active');
          var id = $(this).attr('id');
          $('#offices .tab-content .office-details').fadeOut(300);
          setTimeout(
            function()
            {
              $('#offices .tab-content .'+id).fadeIn(300);
            }, 300);
        }
      });

      $('.dropdown').select2({
        minimumResultsForSearch: Infinity,
        closeOnSelect: true,
        AttachContainer: true,
      });


        $('.dropdown').click(function(){
          this.dropdown._resizeDropdown();
          this.dropdown._positionDropdown();
      });

      $('.dropdown.location, .dropdown.type').change(function() {
          var location = $('.dropdown.location').val();
          var type = $('.dropdown.type').val();
          $('.loading').fadeIn();
          $('.vacancies-content').slideUp(500);
          $.ajax({
              url: ajax_object.ajax_url,
              data: {
                  action: 'vacancies',
                  type: type,
                  location: location,
              },
              type: 'POST',
              success: function(response) {
                  $('.vacancies-content').html(response);
                  $('.vacancies-content').slideDown(500);
                  $('.loading').fadeOut();
              },
          })
      });

      $('.dropdown.order, .dropdown.category').change(function() {
        var category = $('.dropdown.category').val();
        var order = $('.dropdown.order').val();
        $('.loading').fadeIn();
        $('.news-content').slideUp(500);
        $.ajax({
            url: ajax_object.ajax_url,
            data: {
                action: 'news',
                order: order,
                category: category,
            },
            type: 'POST',
            success: function(response) {
                $('.news-content').html(response);
                $('.news-content').slideDown(500);
                $('.loading').fadeOut();
                var $max = $('.max').attr("data-max");
                $(".load-more-news").attr('data-max', $max);
                var $maxparse = parseInt($max);
                if($maxparse <= 6) {
                  $(".load-more-news").fadeOut();
                } else {
                    $(".load-more-news").fadeIn();
                    $(".load-more-news").attr('data-offset', "6");
                }
            },
        })
      });

    });

    $('.news-slide').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.slick-slide').removeClass('slick-style');
      $('.slick-active').addClass('slick-style');
      $('.slick-active').next().next().addClass('slick-style');
    });

    $('.slick-prev').click(function() {
      $('.news-slide').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.slick-slide').removeClass('slick-style');
        $('.slick-active').addClass('slick-style');
        $('.slick-active').prev().prev().addClass('slick-style');
      });

    });

    $(document).ready(function(){
      $('.news-slide').slick({
        slidesToShow: 3,
        //slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        adaptiveHeight: true,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            },
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
        ],
        onInit: function () {
          $('.slick-active').prev().addClass('prev');
          $('.slick-active').next().addClass('next');
        },
      });

      var maxHeight = 0;
      $('.news-list .news-content .news-box .sector-content').each(function(){
        var thisH = $(this).height();
        if (thisH > maxHeight) { maxHeight = thisH; }
      });

      $('.news-list .news-content .news-box .sector-content').height(maxHeight);

      setTimeout(
        function()
        {
          
        
          var maxHeight = 0;
          $('.opinion-slider .news-content').each(function(){
            var thisH = $(this).height();
            if (thisH > maxHeight) { maxHeight = thisH; }
          });

          $('.opinion-slider .news-content').height(maxHeight);

          var maxHeight = 0;
          $('.compliance-slider .news-content').each(function(){
            var thisH = $(this).height();
            if (thisH > maxHeight) { maxHeight = thisH; }
          });

          $('.compliance-slider .news-content').height(maxHeight);

          var maxHeight = 0;
          $('.industry-slider .news-content').each(function(){
            var thisH = $(this).height();
            if (thisH > maxHeight) { maxHeight = thisH; }
          });

          $('.industry-slider .news-content').height(maxHeight);
        }, 1000);
    });

    function slickify(){
      $('.timeline-slider').slick({
        slidesToShow: 5,
        //slidesToScroll: 1,
        infinite: false,
        arrows: false,
        draggable: true,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
              breakpoint: 768,
              settings: "unslick"
          }
      ]
      });
    }

    $(window).resize(function(){
      var $windowWidth = $(window).width();
      if ($windowWidth > 768) {
          slickify();
      }
    });

    $(document).ready(function(){
      
      $('.success-slider').slick({
        slidesToShow: 1,
        //slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        swipeToSlide: true,
      });

      $('.opinion-slider').slick({
        slidesToShow: 3,
        //slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            }
          },
      ]
      });

      $('.compliance-slider').slick({
        slidesToShow: 3,
        //slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            }
          },
      ]
      });

      $('.industry-slider').slick({
        slidesToShow: 3,
        //slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            }
          },
      ]
      });

      $('.case-studie-slide').slick({
        slidesToShow: 3,
        //slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        //cssEase: 'linear',
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      });

      $('.timeline-slider').on('init', function(slick){
        var height = $('.timeline-slider .slick-current .date').height();
        height = height * 2;
        $('.timeline-slider .slick-slide').height(height);
      });

      $('.timeline-slider').on('afterChange', function(event, slick, currentSlide){
        if (currentSlide === 0) {
            $('.timeline .timeline-buttons .prev').removeClass('active');
        } else {
          $('.timeline .timeline-buttons .prev').addClass('active');
        }
        if (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
          $('.timeline .timeline-buttons .next').removeClass('active');
        } else {
          $('.timeline .timeline-buttons .next').addClass('active');
        }
      });

      slickify();

      $('.timeline .prev').click(function(){
        $('.timeline-slider').slick('slickPrev');
      });
      $('.timeline .next').click(function(){
        $('.timeline-slider').slick('slickNext');
      });

      $('.opinion-arrows .left').click(function(){
        $('.opinion-slider').slick('slickPrev');
      });
      $('.opinion-arrows .right').click(function(){
        $('.opinion-slider').slick('slickNext');
      });

      $('.compliance-arrows .left').click(function(){
        $('.compliance-slider').slick('slickPrev');
      });
      $('.compliance-arrows .right').click(function(){
        $('.compliance-slider').slick('slickNext');
      });

      $('.industry-arrows .left').click(function(){
        $('.industry-slider').slick('slickPrev');
      });
      $('.industry-arrows .right').click(function(){
        $('.industry-slider').slick('slickNext');
      });



    });



    $('.left').click(function(){
      $('.success-slider').slick('slickPrev');
    });
    $('.right').click(function(){
      $('.success-slider').slick('slickNext');
    });


    $('.left').click(function(){
      $('.news-slide').slick('slickPrev');
    });
    $('.right').click(function(){
      $('.news-slide').slick('slickNext');
    });


    $('.left').click(function(){
      $('.case-studie-slide').slick('slickPrev');
    });
    $('.right').click(function(){
      $('.case-studie-slide').slick('slickNext');
    });

    var maxheight = $('#menu-third-column').actual('height');

    $('.mm-button').click(function(){
      if($(this).hasClass('open')) {
        $('.mm').removeClass('open');
        setTimeout(
          function()
          {
            $('.mm-content').removeClass('open');
          }, 500);
        setTimeout(
          function()
          {
            $('.mm-button').removeClass('open');
            $('.logo-and-nav').removeClass('open');
            $('.headroom').removeClass('open');
          }, 1000);
          setTimeout(
            function()
            {
              $('#menu-third-column .sub-menu').fadeOut(0);
              $('#menu-third-column > li > a').fadeIn(0);
              $('#menu-third-column').height(maxheight);
            }, 1001);
      } else {
        $('.mm-button').addClass('open');
        $('.logo-and-nav').addClass('open');
        $('.headroom').addClass('open');
        setTimeout(
          function()
          {
            $('.mm-content').addClass('open');
          }, 500);
        setTimeout(
          function()
          {
            $('.mm').addClass('open');
          }, 1000);
      }
    });

    $('.mm-content .third-column .sub-menu').append('<li><a class="back-button">Back</a></li>')

    $('.mm-content .third-column li.menu-item a').click(function(event){
      if($(this).parent().hasClass('menu-item-has-children')){
        event.preventDefault();
        $(this).parent().parent().find("> li > a").not(this).fadeOut(500);
        $(this).fadeOut(500);
        var main = $(this);
        var height = $('#menu-third-column').actual('height');
        $('#menu-third-column').height(height);
        setTimeout(
          function()
          {
            height = $(main).parent().children('.sub-menu').actual('height');
            $('#menu-third-column').height(height);

          }, 500);
          setTimeout(
            function()
            {
              $(main).parent().children('.sub-menu').fadeIn(500);
          }, 1000);

      } else {

      }
    });

    $('.mm-content .third-column a.back-button').click(function(){
      $(this).parent().parent().fadeOut(500);
      setTimeout(
        function()
        {
          $('#menu-third-column').height(maxheight);
        }, 500);
      setTimeout(
        function()
        {
          $('#menu-third-column > li > a').fadeIn(500);
        }, 1000);
    });

    // construct an instance of Headroom, passing the header elemen.

    const header = new Headroom(document.querySelector("#header"), {
      tolerance: 5,
      offset : 205,
      classes: {
        initial: "headroom animated",
        pinned: "headroom--pinned flipInX",
        unpinned: "headroom--unpinned flipOutX"
      }
    });
    header.init();

    $('.accordion-list .accordion-title').click(function(){
      if($(this).hasClass('open')) {
        $(this).removeClass('open')
        $(this).siblings().slideUp();
      } else {
        $('.accordion-list .accordion-title').removeClass('open');
        $('.accordion-list p').slideUp();
        $(this).addClass('open');

        $(this).siblings().slideDown();
      }

    });

    $('.service-box .more').click(function(){
      $(this).fadeOut(250);
      var selector = $(this);
      var currentheight = $(selector).parent().height();
      var contentheight = $(selector).siblings('.extra-content').actual('height');
      var newheight = currentheight + contentheight;
      $(selector).parent().css('height', currentheight);
      $(selector).parent().height(newheight);

      setTimeout(
        function()
        {
          $(selector).siblings('.extra-content').fadeIn();
        }, 600);
    });

    $('.logo-block .more').click(function(){
      if($(this).hasClass('active')){
        var selector = $(this);
        var currentheight = $(selector).parent().height();
        var contentheight = $(selector).parent().find('.extra-content').height();
        var newheight = currentheight - contentheight;
        newheight = newheight + 20;
        $(selector).parent().css('height', currentheight);

        $(selector).parent().find('.extra-content').fadeOut(500);

        setTimeout(
          function()
          {
            $(selector).parent().height(newheight);
            $(selector).siblings('p').find('.dots').fadeIn(0);
          }, 500);
          $(this).removeClass('active');
      } else {
        $(this).siblings('p').find('.dots').fadeOut(500);
        var selector = $(this);
        var currentheight = $(selector).parent().height();
        var contentheight = $(selector).parent().find('.extra-content').actual('height');
        var newheight = currentheight + contentheight;
        $(selector).parent().css('height', currentheight);
        $(selector).parent().height(newheight);

        setTimeout(
          function()
          {
            $(selector).parent().find('.extra-content').fadeIn();
          }, 500);
          $(this).addClass('active');
        }
    });

    let mainNavLinks = document.querySelectorAll(".fixed-section .sticky a");
    let mainSections = document.querySelectorAll(".fixed-section sections");

    let lastId;
    let cur = [];

    window.addEventListener("scroll", event => {
        let fromTop = window.scrollY;

        mainNavLinks.forEach(link => {
            let section = document.querySelector(link.hash);

            if (
                section.offsetTop <= fromTop &&
                section.offsetTop + section.offsetHeight > fromTop
                ) {
                link.classList.add("current");
                } else {
                link.classList.remove("current");
            }
        });
    });

    // Logos slider on mobile
    $('.logos-slider').slick({
      slidesToShow: 2,
      //slidesToScroll: 1,
      mobileFirst: true,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      swipeToSlide: true,
      cssEase: 'linear',
      responsive: [
       {
         breakpoint: 640,
         settings: 'unslick'
       }
      ]
    });

    // Images slider on sector pages
    if(window.innerWidth < 640) {
      $('.columns-slider').slick({
        slidesToShow: 1,
        //slidesToScroll: 1,
        mobileFirst: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        adaptiveHeight: true,
        swipeToSlide: true,
        responsive: [
         {
           breakpoint: 640,
           settings: 'unslick'
         }
        ]
      });

      // Vacancies page slider
      $('.vacancies_image-slider').slick({
        slidesToShow: 1,
        //slidesToScroll: 1,
        mobileFirst: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        adaptiveHeight: true,
        swipeToSlide: true,
        responsive: [
         {
           breakpoint: 640,
           settings: 'unslick'
         }
        ]
      });
    }
    $(".load-more-news").click(function() {
      var $max = $(this).attr("data-max");
      var $offset = $(this).attr("data-offset");
      var $type = $('.dropdown.category').val();
      var $order = $('.dropdown.order').val();
      $('.load-more-news').addClass('loader');
      $.ajax({
          url: ajax_object.ajax_url,
          data: {
              action: 'news_posts',
              offset: $offset,
              type: $type,
              order: $order,
          },
          type: 'POST',
          success: function(response) {
              $('.news-content').append(response);
              $('.loading').fadeOut();
              
              var $newoffset = parseInt($offset) + 6;
              var $maxparse = parseInt($max);
              $('.load-more-news').removeClass('loader');
              if($newoffset >= $maxparse) {
                  $(".load-more-news").fadeOut();
              } else {
                  $(".load-more-news").attr('data-offset', $newoffset);
              }
          },
          
      });
      
    });
    // Video Overlay
    var player;
    $(".js-video").on('click',function(e){
      var $videoID = $(this).data('video-overlay');
      player = new Plyr('#v-'+$videoID+'-player');
      $(this).siblings('[data-video="'+$videoID+'"]').removeClass('hidden');
      player.on('ready', event => {
        if (!navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
          $('#player').show();
            player.play();
          }
      });
    });

    $(document).on('keyup', function(e) {
      if (e.key == "Escape") {
        $('.js-video-overlay').addClass('hidden');
        player.destroy();
      }
    });
    $('.js-close-video-overlay').on('click',function(e) {
      $('.js-video-overlay').addClass('hidden');
      player.destroy();
    });


    $('.video-overlay').on('click', function(e) {
      if (!$(event.target).closest('.plyr').length) {
          $('.js-video-overlay').addClass('hidden');
          player.destroy();
      }        
    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js